import ScaleType from "../../Types/ScaleType";

const ProgressScale = ({
  scale,
  max=100,
  color = "#0D6EFD",
  className = "progressScale",
}: ScaleType) => {
  return (
    <div className={className}>
      <div
        className="fill"
        style={{
          width: `${scale ? (scale / max) * 100 : 0}%`,
          backgroundColor: color,
        }}
      ></div>
    </div>
  );
};

export default ProgressScale;
